module.exports = __webpack_public_path__ + "src/img/artist/indexpic06.jpg?f85758b9be7a746365a3caacaf082414";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic06.jpg
// module id = 133
// module chunks = 0